<section class="detail-shell">
  <div class="detail-topbar">
    <button class="btn btn-outline-secondary btn-sm" (click)="goBack()">Back to users</button>
    <div class="status-chip">User #{{ userItem.userId }}</div>
  </div>

  <div class="profile-card">
    <img
      class="hero-photo"
      [src]="userItem.profilePicture || defaultUserImage"
      (error)="onImageError($event)"
      alt="Profile"
    />
    <div class="hero-meta">
      <h3>{{ displayValue(userItem.firstName) }} {{ displayValue(userItem.lastName) }}</h3>
      <p>&#64;{{ displayValue(userItem.userName) }}</p>
      <div class="meta-row">
        <span>{{ displayValue(userItem.email) }}</span>
        <span>{{ displayValue(userItem.mobileNo) }}</span>
        <span>Last seen: {{ formatLastSeen(userItem.lastSeenTs) }}</span>
      </div>
      <div class="stat-row">
        <div><strong>{{ userItem.totalConnections || 0 }}</strong><small>Total Connections</small></div>
        <div><strong>{{ userItem.totalActiveConnections || 0 }}</strong><small>Active Connections</small></div>
        <div><strong>{{ boolLabel(userItem.active) }}</strong><small>Active Account</small></div>
      </div>
    </div>
  </div>

  <div class="detail-grid">
    <article class="info-card">
      <h5>Profile</h5>
      <dl>
        <dt>Gender</dt><dd>{{ displayValue(userItem.gender) }}</dd>
        <dt>Date of birth</dt><dd>{{ displayValue(userItem.dob) }}</dd>
        <dt>Mobile code</dt><dd>{{ displayValue(userItem.mobileCode) }}</dd>
        <dt>About</dt><dd>{{ displayValue(userItem.aboutText) }}</dd>
      </dl>
    </article>

    <article class="info-card">
      <h5>Preferences</h5>
      <dl>
        <dt>Reasons for KnoMi</dt><dd>{{ displayValue(userItem.reasonsForKnoMi) }}</dd>
        <dt>Favorite drinks</dt><dd>{{ displayValue(userItem.favoriteDrinks) }}</dd>
        <dt>Favorite foods</dt><dd>{{ displayValue(userItem.favoriteFoods) }}</dd>
        <dt>Education</dt><dd>{{ displayValue(userItem.education) }}</dd>
        <dt>Occupation</dt><dd>{{ displayValue(userItem.occupation) }}</dd>
      </dl>
    </article>

    <article class="info-card">
      <h5>Discover & Location</h5>
      <dl>
        <dt>Discover enabled</dt><dd>{{ boolLabel(userItem.discoverEnabled) }}</dd>
        <dt>Last location time</dt><dd>{{ displayValue(userItem.lastGeoLocationTs) }}</dd>
        <dt>Latitude</dt><dd>{{ displayValue(userItem.lastLat) }}</dd>
        <dt>Longitude</dt><dd>{{ displayValue(userItem.lastLon) }}</dd>
        <dt>Distance type</dt><dd>{{ displayValue(userItem.distanceMeasurementType) }}</dd>
      </dl>
    </article>

    <article class="info-card">
      <h5>Membership & Verification</h5>
      <dl>
        <dt>Membership type</dt><dd>{{ displayValue(userItem.membershipType) }}</dd>
        <dt>Subscription code</dt><dd>{{ displayValue(userItem.subscriptionCode) }}</dd>
        <dt>Deleted</dt><dd>{{ boolLabel(userItem.deleted) }}</dd>
        <dt>Active</dt><dd>{{ boolLabel(userItem.active) }}</dd>
        <dt>Last seen</dt><dd>{{ formatLastSeen(userItem.lastSeenTs) }}</dd>
        <dt>Verification status</dt><dd>{{ displayValue(userItem.verificationStatus) }}</dd>
      </dl>
      <div class="action-row">
        <button class="btn btn-sm btn-primary" *ngIf="userItem.verificationStatus === 2" (click)="onVerify(userItem.profilePicture)">Verify with main photo</button>
        <button class="btn btn-sm btn-outline-danger" *ngIf="userItem.verificationStatus === 2 || userItem.verificationStatus === 3" (click)="onUnverify()">Unverify</button>
      </div>
    </article>
  </div>

  <article class="info-card">
    <h5>Profile Photos</h5>
    <div class="photo-row">
      <img class="photo" [src]="userItem.profilePicture || defaultUserImage" (error)="onImageError($event)" alt="profile 1" />
      <img class="photo" [src]="userItem.profilePicture2 || defaultUserImage" (error)="onImageError($event)" alt="profile 2" />
      <img class="photo" [src]="userItem.profilePicture3 || defaultUserImage" (error)="onImageError($event)" alt="profile 3" />
      <img class="photo" [src]="userItem.profilePicture4 || defaultUserImage" (error)="onImageError($event)" alt="profile 4" />
      <img class="photo" [src]="userItem.verificationPhoto || defaultUserImage" (error)="onImageError($event)" alt="verification" />
    </div>
  </article>
</section>

<div *ngIf="false">


<div class="row">

    <div class="col-4">
        <div class="col-12">

            <div class="card">
                <div class="card-header">
                    <div class="card-title">
                        Profile Details
                    </div>
                </div>
                <div class="card-body">
                    <div class="col-12">
                        <div class="input-group">
                            <span class="input-group-text" id="basic-addon3">User Name</span>
                            <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                value="{{userItem.userName}}">

                        </div>
                    </div>

                    <div class="col-12">
                        <div class="input-group ">
                            <span class="input-group-text" id="basic-addon3">First Name</span>
                            <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                value="{{userItem.firstName}}">

                        </div>
                    </div>

                    <div class="col-12">
                        <div class="input-group ">
                            <span class="input-group-text" id="basic-addon3">Email</span>
                            <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                value="{{userItem.email}}">

                        </div>
                    </div>

                    <div class="col-12">
                        <div class="input-group ">
                            <span class="input-group-text" id="basic-addon3">Gender</span>
                            <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                value="{{userItem.gender}}">

                        </div>
                    </div>
                    <div class="col-12">
                        <div class="input-group ">
                            <span class="input-group-text" id="basic-addon3">Bithday</span>
                            <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                value="{{userItem.dob}}">

                        </div>
                    </div>


                    <div class="col-12">
                        <div class="input-group ">
                            <span class="input-group-text" id="basic-addon3">Mobile Code</span>
                            <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                value="{{userItem.mobileCode}}">

                        </div>
                    </div>
                    <div class="col-12">
                        <div class="input-group ">
                            <span class="input-group-text" id="basic-addon3">Mobile No</span>
                            <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                value="{{userItem.mobileNo}}">

                        </div>

                    </div>
                    <div class="col-12">
                        <div class="input-group">
                            <span style="height:15vh" class="input-group-text" id="basic-addon3">About</span>
                            <textarea style="height: 15vh;text-wrap:wrap;max-height: 15vh;min-height: 15vh;"
                                [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                value="{{userItem.aboutText}}"></textarea>

                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="col-12">
            <div class="card ">
                <div class="card-header">
                    <div class="card-title">
                        Profile Preferences
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Reasons for KnoMi</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.reasonsForKnoMi}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Bars</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.bars}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Restaurants</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.restaurants}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Favorite Drinks</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.favoriteDrinks}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Favorite Foods</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.favoriteFoods}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Education</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.education}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Occupation</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.occupation}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Hometown</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.hometown}}">

                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>

    <div class="col-8">
        <div class="row">
            <div class="col-6">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">
                            Discover
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" style="min-width: 225px;">Dicover Enabled</span>
                                <input [readOnly]="true" class="form-check-input form-control-sm" disabled="disabled"
                                    type="checkbox" placeholder="" value="{{userItem.discoverEnabled}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" style="min-width: 225px;">Last Geo Location TS</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.lastGeoLocationTs}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" style="min-width: 225px;">Last Lat</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.lastLat}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" style="min-width: 225px;">Last Lon</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.lastLon}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" style="min-width: 225px;">Distance Measurement
                                    Type</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.distanceMeasurementType}}">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">


                <div class="card">
                    <div class="card-header">
                        <div class="card-title">
                            Settings and Membership
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Active</span>
                                <input [readOnly]="true" disabled="disabled" [(ngModel)]="userItem.active"
                                    class="form-check-input form-control-sm" type="checkbox" placeholder="">


                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Deleted</span>
                                <input [readOnly]="true" class="form-check-input form-control-sm" disabled="disabled"
                                    type="checkbox" placeholder="" value="{{userItem.deleted}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Membership Type</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.membershipType}}">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Subscription Code</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.subscriptionCode}}">

                            </div>
                        </div>

                        <div class="col-12">

                            <div class="input-group ">
                                <span class="input-group-text" id="basic-addon3">Push Token</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="text" placeholder=""
                                    value="{{userItem.pushToken}}">

                            </div>


                        </div>
                    </div>
                </div>



            </div>
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">
                            Profile Pictures
                            <span *ngIf="userItem.verificationStatus === 2">Pending Verification
                                <button class="btn btn-danger btn-sm" (click)="onUnverify()">Deny Verification</button>
                            </span>
                            <span *ngIf="userItem.verificationStatus === 1">Unverified</span>
                            <span *ngIf="userItem.verificationStatus === 3">Verified</span>
                            <button style="margin-left: 5px;" *ngIf="userItem.verificationStatus === 3"
                                class="btn btn-primary btn-sm" (click)="onUnverify()">Unverifiy</button>
                        </div>

                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div class="col-2 col-lg-2  text-center">
                                <img class="profilePicture" [src]="userItem.profilePicture" />

                                <div class="  text-center">
                                    <button
                                        *ngIf="userItem.verificationStatus === 2 && userItem.profilePicture.indexOf('user.png')  <=0"
                                        (click)="onVerify(userItem.profilePicture)" class="btn btn-primary">Verify
                                    </button>
                                    <h5 *ngIf="userItem.confirmVerificationPhoto == userItem.profilePicture">
                                        Verified
                                    </h5>
                                </div>
                            </div>
                            <div class="col-2 col-lg-2  text-center">
                                <img class="profilePicture" [src]="userItem.profilePicture2" />
                                <div class="  text-center">
                                    <button
                                        *ngIf="userItem.verificationStatus === 2  && userItem.profilePicture2.indexOf('user.png')  <=0"
                                        (click)="onVerify(userItem.profilePicture2)"
                                        class="btn btn-primary">Verify</button>
                                    <h5 *ngIf="userItem.confirmVerificationPhoto == userItem.profilePicture2">Verified
                                    </h5>

                                </div>
                            </div>
                            <div class="col-2 col-lg-2  text-center">
                                <img class="profilePicture" [src]="userItem.profilePicture3" />
                                <div class="  text-center">
                                    <button
                                        *ngIf="userItem.verificationStatus === 2 && userItem.profilePicture3.indexOf('user.png') <=0"
                                        (click)="onVerify(userItem.profilePicture3)"
                                        class="btn btn-primary">Verify</button>
                                    <h5 *ngIf="userItem.confirmVerificationPhoto == userItem.profilePicture3">Verified
                                    </h5>
                                </div>
                            </div>
                            <div class="col-2 col-lg-2  text-center">
                                <img class="profilePicture" [src]="userItem.profilePicture4" />
                                <div class="  text-center">
                                    <button
                                        *ngIf="userItem.verificationStatus === 2 && userItem.profilePicture4.indexOf('user.png') <=0"
                                        (click)="onVerify(userItem.profilePicture4)"
                                        class="btn btn-primary">Verify</button>
                                    <h5 *ngIf="userItem.confirmVerificationPhoto == userItem.profilePicture4">Verified
                                    </h5>

                                </div>
                            </div>
                            <div class="col-2 col-lg-2  text-center">
                                <img class="profilePicture" [src]="userItem.verificationPhoto" />
                                <h5>Verification Photo</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">
                            Connections
                        </div>

                    </div>
                    <div class="card-body">
                        <div class="col-4">
                            <div class="input-group ">
                                <span class="input-group-text" style="min-width: 200px;">Total Connections</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="number"
                                    placeholder="" value="{{userItem.totalConnections}}">

                            </div>
                        </div>
                        <div class="col-4">
                            <div class="input-group ">
                                <span class="input-group-text" style="min-width: 200px;">Total Active Connections</span>
                                <input [readOnly]="true" class="form-control form-control-sm" type="number"
                                    placeholder="" value="{{userItem.totalActiveConnections}}">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>




</div>


</div>

<kendo-dialog title="Please confirm" *ngIf="verifyDialogOpened" [minWidth]="250" [width]="450">
    <p style="margin: 30px; text-align: center;">
        Are you sure you would like to use this photo to verify this profile
    </p>

    <kendo-dialog-actions>
        <button kendoButton (click)="closeVerification('no')">No</button>
        <button kendoButton (click)="closeVerification('yes')">
            Yes
        </button>
    </kendo-dialog-actions>
</kendo-dialog>


<kendo-dialog title="Please confirm" *ngIf="unverifyDialogOpened" [minWidth]="250" [width]="450">
    <p style="margin: 30px; text-align: center;">
        Are you sure you would like to use this unverify this profile. Please provide a reason
    </p>
    <input [(ngModel)]="reason" type="text" class="form-control" placeholder="enter your reason here" />
    <kendo-dialog-actions>
        <button kendoButton (click)="onUnverifyDialogClosed('no')">No</button>
        <button kendoButton (click)="onUnverifyDialogClosed('yes')">
            Yes
        </button>
    </kendo-dialog-actions>
</kendo-dialog>